const config = {
  rowSelection: false,
  columns: [
    {
      title: '开具时间',
      dataIndex: 'invoiceIssuanceDate',
      itemType: 'date',
      width: 160,
    },
    {
      title: '发票代码',
      dataIndex: 'invoiceCode',
      ellipsis: true,
      width: 150
    },
    {
      title: '发票号码',
      dataIndex: 'invoiceNumber',
      ellipsis: true,
      width: 140,
    },
    {
      title: '发票类型',
      dataIndex: 'invoiceTypeName',
      width: 140,
    },
    {
      title: '交易类型',
      dataIndex: 'transactionTypeName',
      width: 140,
    },
    {
      title: '发票金额（含税价）',
      dataIndex: 'amount',
      width: 180
    },
    {
      title: '税率',
      dataIndex: 'taxRateCode',
      width: 100,
      render: 'taxRateCodeOperate',
    },
    {
      title: '税额',
      dataIndex: 'taxAmount',
      width: 100
    },
    {
      title: '不含税金额',
      dataIndex: 'excludeTaxAmount',
      width: 140,
      render: 'excludeTaxAmountOperate',
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 160,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  search: [],
  footer: [
    {
      label: '新增',
      type: 'primary',
      auth: 'InvoiceRegistrationAdd',
      events: ['onClick:onAdd'],
    },
  ]
}
export default config
